import "reflect-metadata";
import App from "@/App";

const app: App = new App();

app.start();
